import { useAuth } from 'contexts/AuthContext';
import s from './LogInSignUp.module.css';
import { useState } from 'react';
import LogInForm from './LogInSignUpComponents.js/LogInForm';
import SignUpForm from './LogInSignUpComponents.js/SignUpForm';

const NewLogInSignUp = () => {
    const [loginToggled, setLoginToggled] = useState(false);
    const [signUpSuccess, setSignupSuccess] = useState(false);

    const { user } = useAuth();

    if (user) {
        window.location.href = '/';
        return null;
    }

    if (signUpSuccess) {
        return (
            <div className={s.page}>
                <TopBar />
                <main className={s.successMain}>
                    <div className={s.successCard}>
                        <img
                            src={process.env.PUBLIC_URL + '/logo.png'}
                            alt="Quadratik"
                            className={s.successImage}
                        />
                        <p className={s.eyebrow}>You're in</p>
                        <h1 className={s.successTitle}>Sign up successful.</h1>
                        <p className={s.successSubtitle}>
                            Please verify your account via the email we just sent you.
                        </p>
                    </div>
                </main>
            </div>
        );
    }

    const isSignUp = !loginToggled;

    return (
        <div className={s.page}>
            <TopBar />
            <main className={s.main}>
                <div className={s.container}>
                    <div className={s.formSide}>
                        <p className={s.eyebrow}>
                            {isSignUp ? 'Start for free' : 'Welcome back'}
                        </p>
                        <h1 className={s.heading}>
                            {isSignUp
                                ? 'Create your Quadratik account.'
                                : 'Log in to Quadratik.'}
                        </h1>
                        <p className={s.subheading}>
                            {isSignUp
                                ? '100B+ validated data points, zero caps.'
                                : 'Pick up where you left off.'}
                        </p>

                        <div className={s.toggleWrap}>
                            <div className={s.toggle}>
                                <button
                                    type="button"
                                    className={`${s.toggleItem} ${isSignUp ? s.toggleActive : ''}`}
                                    onClick={() => setLoginToggled(false)}
                                >
                                    Sign Up
                                </button>
                                <button
                                    type="button"
                                    className={`${s.toggleItem} ${!isSignUp ? s.toggleActive : ''}`}
                                    onClick={() => setLoginToggled(true)}
                                >
                                    Log In
                                </button>
                            </div>
                        </div>

                        <div className={s.formSlot}>
                            {loginToggled ? (
                                <LogInForm />
                            ) : (
                                <SignUpForm
                                    signUpSuccess={signUpSuccess}
                                    setSignupSuccess={setSignupSuccess}
                                />
                            )}
                        </div>
                    </div>

                    <aside className={s.socialSide}>
                        <p className={s.eyebrow}>Customer story</p>
                        <p className={s.quote}>
                            &ldquo;Worth its weight in <span className={s.quoteAccent}>gold</span>.&rdquo;
                        </p>

                        <div className={s.authorRow}>
                            <img
                                src={process.env.PUBLIC_URL + '/oliver_bogner.png'}
                                alt="Oliver Bogner"
                                className={s.authorPhoto}
                            />
                            <div className={s.authorDescription}>
                                <div className={s.authorName}>Oliver Bogner</div>
                                <div className={s.authorTitle}>CEO, Team GO Ventures (MPG)</div>
                                <div className={s.authorCredentials}>
                                    2&times; Inc 5000 &middot; 2&times; Forbes 30 Under 30
                                </div>
                            </div>
                        </div>

                        <div className={s.imageRow}>
                            <img src={process.env.PUBLIC_URL + '/go-ventures-logo.png'} alt="Team GO Ventures" />
                            <img src={process.env.PUBLIC_URL + '/forbes_30_under_30_logo.png'} alt="Forbes 30 Under 30" />
                            <img src={process.env.PUBLIC_URL + '/inc_5000_logo.png'} alt="Inc 5000" />
                        </div>
                    </aside>
                </div>
            </main>
        </div>
    );
};

function TopBar() {
    return (
        <nav className={s.nav}>
            <a href="/" className={s.brand}>
                <img
                    src={process.env.PUBLIC_URL + '/logo.png'}
                    alt="Quadratik logo"
                    className={s.brandLogo}
                />
                <span className={s.brandName}>Quadratik</span>
            </a>
        </nav>
    );
}

export default NewLogInSignUp;
